var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticStyle:{"width":"400px"}},[_c('v-text-field',{attrs:{"prepend-inner-icon":"mdi-magnify","color":"#310059","dense":"","outlined":"","label":"Search..."},on:{"keyup":_vm.searchList},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }